<div class="choose-delivery-tabs">

  <ng-container *ngFor="let method of paymentMethods; let i = index">
    <ui-btn-two-lines
      *ngIf="method.type !== PAYMENT_PLATFORM_TYPES.directVipps"
      class="d-block"
      [btnColor]="btnColor"
      [class.mt-md-max-3]="i > 0"
      [icon]="method.icon"
      [title]="method.title"
      [info]="method.info"
      [disabled]="isBlocked(method.type)"
      [extraClasses]="'w-100-lg-max ' + (method.type === paymentType? 'selected' : '')"
      [size]="size"
      (onClick)="paymentType = method.type">
    </ui-btn-two-lines>

    <vipps-btn
      *ngIf="method.type === PAYMENT_PLATFORM_TYPES.directVipps"
      class="d-block"
      [class.mt-md-max-3]="i > 0"
      [extraClasses]="'w-100-lg-max'"
      [size]="size"
      [selected]="method.type === paymentType"
      (click)="paymentType = method.type"
    ></vipps-btn>
  </ng-container>
</div>
